import React from "react";

/**
 * Where a text goes out from: the agent's own mobile or the COLLINGS sender.
 *
 * Genneva Smarrelli (CRM-2026-00138, 2 Nov 2026): "No option to select sms to
 * be sent from Collings". Once an agent's own number is an active sender every
 * text went from it, with no way back to COLLINGS. The agent block at the end
 * of the text still names who to call either way.
 *
 * `agentSender` is the lookup for the agent's own number (useSmsSender). Only
 * shown when there is a choice to make: an agent without an active own number
 * always sends from COLLINGS.
 */
export default function SmsSendFrom({ agentSender, fromCollings, onChange, className = "" }) {
  if (!agentSender?.own_number && !fromCollings) return null;
  const option = (value, label) => (
    <label className="flex items-center gap-2 text-xs text-gray-700 cursor-pointer">
      <input
        type="radio"
        name="sms-send-from"
        checked={fromCollings === value}
        onChange={() => onChange(value)}
      />
      {label}
    </label>
  );
  return (
    <div data-testid="sms-send-from" className={`space-y-1 ${className}`}>
      <p className="text-xs font-semibold text-gray-600">Send from</p>
      {option(false, agentSender?.own_number ? `Agent's mobile (${agentSender.sender})` : "Agent's mobile")}
      {option(true, "COLLINGS")}
    </div>
  );
}
